import React, {  useMemo, useState } from "react";
import { ComboBox, IComboBox, IComboBoxOption, IComboBoxStyles, IDropdownOption } from "@fluentui/react";
import { stringDefaultValue } from "../../../../../utils";
import { MultipleSelectorFilterStyle } from "./multipleSelectorFilterStyle.jss";
import { useTheme } from "react-jss";

interface IMultipleSelectorFilterprops {
    selectedKeys: string[];
    onChange: (name: string, value: any) => any;
    options: IComboBoxOption[];
    label: string;
    isDisabled?: boolean;
    propertyName: string;
    isRequired?: boolean;
    customFilteredOptions?:(filteredText:string) =>IDropdownOption[]
}

export const MultipleStringSelectorFilter: React.FC<IMultipleSelectorFilterprops> = ({
    label,
    onChange,
    options,
    selectedKeys,
    isDisabled,
    propertyName,
    customFilteredOptions
}) => {
    const theme = useTheme();
    const style = MultipleSelectorFilterStyle({ theme });

    const comboBoxStyles: Partial<IComboBoxStyles> = {
        container: style.root,
        callout: style.callout,
        label: style.label,
        input: style.inputText,
        optionsContainer: style.optionsContainer,
    
    };

    const comboBoxRef = React.useRef<IComboBox>(null);
    const [filteredText, setFilteredText] = useState<string>("");

    const onOpenClick = React.useCallback(() => {
        comboBoxRef.current?.focus(true);
    }, []);

    const optionsWithDefault = useMemo(() => {
        const defaultValueArray: IDropdownOption[] = [stringDefaultValue];
        return defaultValueArray.concat(options);
    }, [options]);

    const onOptionSelected = (option?: IDropdownOption) => {
        if (option) {
            if (String(option.key) === String(stringDefaultValue.key) && option.selected) {
                onChange(propertyName, [String(stringDefaultValue.key)]);
            } else {
                const newKeys = option?.selected ? [...selectedKeys, String(option.key)] : selectedKeys.filter((key) => key !== String(option.key));
                let newKeysFiltered: string[] = [];
                switch (newKeys.length) {
                    case 1:
                        newKeysFiltered = newKeys;
                        break;
                    case 0:
                        newKeysFiltered = [String(stringDefaultValue.key)];
                        break;
                    default:
                        const optionsWithoutDefaultValue = newKeys.filter((key) => key !== String(stringDefaultValue.key));
                        newKeysFiltered =
                            options.length === optionsWithoutDefaultValue.length ? [String(stringDefaultValue.key)] : optionsWithoutDefaultValue;
                        break;
                }
                onChange(propertyName, newKeysFiltered);
            }
        }
    };

    const onRenderItem = (option: any, defaultRender: any) => {
        return <div style={{ display: "flex", alignItems: "center" }}>{defaultRender(option)}</div>;
    };

    const onFilterOption = useMemo(() => {
        if (!filteredText) {
            return optionsWithDefault;
        } else if (customFilteredOptions) {
            return customFilteredOptions(filteredText);
        }

        return optionsWithDefault.filter((item) => {
            let filter = filteredText && item.text.toLocaleLowerCase().includes(filteredText.toLocaleLowerCase());
            return filter;
        });
    }, [filteredText, optionsWithDefault, customFilteredOptions]);

    return (
        <div className={style.container}>
            <ComboBox
                componentRef={comboBoxRef}
                multiSelect
                autoComplete="off"
                selectedKey={selectedKeys}
                label={label}
                options={onFilterOption}
                onRenderItem={onRenderItem}
                onChange={(_: any, option: any) => {
                    onOptionSelected(option);
                }}
                allowFreeform={true}
                styles={comboBoxStyles}
                onInputValueChange={(value: any) => {
                    onOpenClick();
                    setFilteredText(value);
                }}
                onClick={() => {
                    onOpenClick();
                }}
                onMenuDismiss={() => {
                    setFilteredText("");
                }}
                disabled={isDisabled}
            />
        </div>
    );
};
